import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { CspConfigMenuActionsType } from 'routes/CspConfig/CspConfig.types';
import ModalDialog from 'shared/modal/dialog';
import { CspConfig } from 'data/cspConfig/cspConfig.types';
import './csp-config-list-menu.scss';

type Props = {
  selectedCspConfig?: CspConfig;
  hasPrivilegeToCreateNew: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const CspConfigListMenu: FunctionComponent<Props> = ({
  selectedCspConfig,
  hasPrivilegeToCreateNew,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedCspConfig == null) {
    return null;
  }

  return (
    <div data-testid="CspConfigListMenu" className="csp-config-list-menu">
      {hasPrivilegeToCreateNew && (
        <Button
          className="csp-config-list-menu-button"
          data-testid={`${CspConfigMenuActionsType.Edit}-button`}
          text={t('cspConfig.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="csp-config-list-menu-button"
          data-testid={`${CspConfigMenuActionsType.Delete}-button`}
          text={t('cspConfig.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('cspConfig.deletePopup.title')}
        displayMessage={t('cspConfig.deletePopup.message', { name: selectedCspConfig.name })}
        actionText={t('cspConfig.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default CspConfigListMenu;
